export default __webpack_public_path__ + "static/media/placeholder_dummy2016-schmuck01-de-mobile.7f30adf0.png";